define('enums/composer/visibilityConditionOperation',[],function () {
    'use strict';

    return {
        AND: 'AND',
        OR: 'OR'
    };
});
